import { FileService } from 'app/_services/file.service';
import { SiteFormResponse } from '../site-forms/site-form-response.model';
import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';

@Injectable()
export class SiteFormResponseFactory {
  constructor(private fileService: FileService) {
  }

  public createAndFetchImages(input: any): SiteFormResponse {
    const siteFormResponse = new SiteFormResponse().deserialize(input);

    siteFormResponse.form.data.forEach((field, i) => {
      if (field.type === 'imageUpload') {
        this.getImagesUrls(field, siteFormResponse.getAnswerArray(i));
      }
      if (field.type === 'documentUpload') {
        siteFormResponse.attachments.push(...siteFormResponse.getAnswerArray(i));
      }
    });

    return siteFormResponse;
  }

  private getImagesUrls(field, urls: string[]) {
    field.imageUrls = [];
    field.objectUrls = [];

    if (urls) {
      const observables = urls.map(url => this.fileService.getSiteFormResponsePhoto(url));

      forkJoin(observables).subscribe(results => {
        results.forEach(imageData => {
          field.imageUrls.push(imageData.safeUrl);
          field.objectUrls.push(imageData.objectUrl);
        });
      });
    }
  }
}
